export enum ContentType {
	FormData = "multipart/form-data",
	Json = "application/json;charset=UTF-8",
}
